module.exports = __webpack_public_path__ + "static/media/logout.4061aebe.svg";